export default __webpack_public_path__ + "static/media/Page26.7b263c61.txt";